import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './locales/en'
import id from './locales/id'

Vue.use(VueI18n)

export default new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: { en, id },
  silentFallbackWarn: true
})
